import React from 'react';
import { REDUCER_NAME } from '../reducer';
import { connect } from 'react-redux';
import { compose } from 'redux';
import TablePutThrough from './TablePutThrough';
import { I18n } from 'react-redux-i18n';

const mapStateToProps = state => {
  return {
    i18n: state.i18n,
    listDataRealTimePutThrough: state[REDUCER_NAME].listDataRealTimePutThrough,
    listPutThroughHnx: state[REDUCER_NAME].listPutThroughHnx,
  };
};

const enhance = compose(connect(mapStateToProps));

export default enhance(TablePutThroughHnx);

function TablePutThroughHnx(props) {
  const { listDataRealTimePutThrough, listPutThroughHnx } = props;
  const realTimeData = listDataRealTimePutThrough.HNXIndex;
  return (
    <TablePutThrough
      {...props}
      realTimeData={realTimeData}
      data={listPutThroughHnx}
      name={I18n.t(`watchListSummary.listTitleTablePutThrough.hnx`)}
    />
  );
}
